var React = require('react');

function Ellipsis (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2 6.5C2.82875 6.5 3.5 7.17125 3.5 8C3.5 8.82875 2.82875 9.5 2 9.5C1.17125 9.5 0.5 8.82875 0.5 8C0.5 7.17125 1.17125 6.5 2 6.5Z","fill":"#181818","key":0}),React.createElement("path",{"d":"M8 6.5C8.82875 6.5 9.5 7.17125 9.5 8C9.5 8.82875 8.82875 9.5 8 9.5C7.17125 9.5 6.5 8.82875 6.5 8C6.5 7.17125 7.17125 6.5 8 6.5Z","fill":"#181818","key":1}),React.createElement("path",{"d":"M15.5 8C15.5 7.17125 14.8287 6.5 14 6.5C13.1713 6.5 12.5 7.17125 12.5 8C12.5 8.82875 13.1713 9.5 14 9.5C14.8287 9.5 15.5 8.82875 15.5 8Z","fill":"#181818","key":2})]);
}

Ellipsis.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Ellipsis;

Ellipsis.default = Ellipsis;
